import React, { useEffect } from 'react'
import { addWeldingLogOne } from '../../../api/welding.api'
import * as actions from '../../../reducers/form';
import SimpleAdd from '../../../components/SimpleAdd'
import { enqueueSnackbar } from '../../../reducers/notifier'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import validateProps from '../../../functions/validateProps'

const formName = 'WeldingLogAdd'
const arrProps = [
  {
    bp: { xs: 12 },
    field: 'name', label: 'Наименование', type: 'text',
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    bp: { xs: 6 },
    field: 'dateStart', label: 'Дата начала журнала', type: 'text', textProps: { type: 'date' }, labelProps: { shrink: true },
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    bp: { xs: 6 },
    field: 'dateEnd', label: 'Дата окончания журнала', type: 'text', textProps: { type: 'date' }, labelProps: { shrink: true },
  },
]
export default function WeldingLogAdd(props) {
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(actions.formInitialize({
      name: '', dateStart: null, dateEnd: null,
      errorValidate: { name: false, dateStart: false }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const handleSave = (e) => {
    const { values } = form
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        name: values.name,
        dateStart: values.dateStart,
        dateEnd: values.dateEnd
      },
      url: addWeldingLogOne.path({ id: props.match.params.idProject }),
      method: addWeldingLogOne.type,
      history: history
    }, formName))
  }
  return <div className='App-paper'>
    <form autoComplete="off" onSubmit={handleSave}>
      <div style={{ padding: '16px' }}>
        <SimpleAdd
          formName={formName}
          arr={arrProps}
          title='Добавить журнал сварочных работ'
          gridProps={{ sm: 12, md: 6 }}
        />
      </div>
      <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
      <Button type="submit" color="primary">Сохранить</Button>
    </form>
  </div>
}